export interface Chapter {
  id: number;
  title: string;
  date: string;
}

export interface ArticleContent {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  category: string;
  categoryName: string;
  summary: string;
  tags: string[];
  views: number;
  status: string;
  chapters: Chapter[];
  descriptionHtml: string;
  faqs: { question: string; answer: string }[];
}

export const categoryNameMap: Record<string, string> = {
  romance: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  comedy: '搞笑',
  thriller: '悬疑',
  drama: '剧情',
  horror: '恐怖',
};

export const articleData: Record<number, ArticleContent> = {
  1: {
    id: 1,
    title: '秘密花园',
    author: '李智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20with%20two%20lovers%20in%20a%20flower%20garden%2C%20soft%20warm%20lighting%2C%20delicate%20watercolor%20illustration%20style%2C%20gentle%20pastel%20tones%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20clean%20composition%20with%20beautiful%20character%20designs%20and%20floral%20elements&width=600&height=850&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    category: 'romance',
    categoryName: '恋爱',
    summary: '一段跨越阶级的爱情故事，富家千金与普通画家的偶然相遇，在秘密花园中展开了一段动人心弦的浪漫旅程。',
    tags: ['恋爱', '都市', '治愈'],
    views: 2850000,
    status: '连载中',
    chapters: Array.from({ length: 128 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《秘密花园》是由韩国著名漫画家李智慧创作的一部浪漫爱情漫画，自连载以来以其精美的画风和动人的故事情节深受广大读者喜爱，累计阅读量已突破285万次。</p>
      <p>故事讲述了出身豪门的尹素熙在自家庄园的秘密花园中偶然邂逅了一位正在作画的年轻画家金泰俊。素熙厌倦了被安排好的人生，而泰俊自由的灵魂和艺术才华深深吸引了她。两人在秘密花园中分享彼此最真实的一面，一段跨越阶级的纯真爱情悄然绽放。</p>
      <p>然而，素熙的家族早已为她规划好未来，包括与另一家财阀的联姻。面对家族的压力和社会的偏见，素熙必须做出选择：遵循既定的命运，还是追随内心的真爱。</p>
      <p>本作以其细腻的情感描写、精美的花卉背景绘制和对社会阶级问题的深刻探讨而备受好评，被誉为近年来最优秀的韩国恋爱漫画之一。</p>
    `,
    faqs: [
      { question: '《秘密花园》漫画多久更新一次？', answer: '《秘密花园》目前为连载中状态，通常每周更新一话，更新时间一般在每周四的晚上。具体更新情况请关注网站公告。' },
      { question: '《秘密花园》漫画共有多少话？', answer: '截止目前，《秘密花园》已连载至第128话，作者李智慧表示整个故事大约会持续150-160话左右。' },
      { question: '在哪里可以免费阅读《秘密花园》全集？', answer: '韩国漫画网提供《秘密花园》全集免费在线观看，您可以在本站搜索《秘密花园》或直接在分类页面中找到该作品进行阅读。' },
    ],
  },
  2: {
    id: 2,
    title: '剑与魔法',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20a%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20realm%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%20with%20sparkles%2C%20Korean%20webtoon%20art%20style%2C%20dynamic%20composition%2C%20rich%20colors%20with%20golden%20and%20deep%20blue%20accents&width=600&height=850&seq=comic-cover-02&orientation=portrait',
    rating: 9.3,
    category: 'fantasy',
    categoryName: '奇幻',
    summary: '在剑与魔法并存的世界中，一位平凡少年意外觉醒远古魔力，踏上寻找传说之剑的征程。',
    tags: ['奇幻', '冒险', '战斗'],
    views: 2100000,
    status: '连载中',
    chapters: Array.from({ length: 96 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《剑与魔法》是金泰亨创作的热血奇幻漫画，凭借宏大的世界观和精彩的战斗场面，成为本站最受欢迎的韩国漫画之一。</p>
      <p>在一个剑与魔法并存的世界，从未接触过魔力的少年韩宇在一次意外中觉醒了沉睡千年的远古魔力。他必须踏上寻找传说之剑的征程，在旅途中结识了精灵弓箭手艾琳、兽人战士巴鲁和神秘法师露娜，组成了最不可思议的冒险小队。</p>
      <p>黑暗势力正在复苏，远古魔王的封印即将被打破，韩宇和他的伙伴们必须赶在末日降临之前找到传说中的圣剑，拯救这个即将被黑暗吞噬的世界。</p>
    `,
    faqs: [
      { question: '《剑与魔法》是韩国漫画还是日本漫画？', answer: '《剑与魔法》是由韩国漫画家金泰亨创作的韩国漫画（韩漫），采用了韩国网漫的纵向阅读格式，在韩国漫画网可以免费在线观看。' },
    ],
  },
  3: {
    id: 3,
    title: '都市猎人',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20comic%20cover%20with%20a%20cool%20fighter%20in%20urban%20night%20cityscape%20background%2C%20dynamic%20action%20pose%2C%20neon%20lights%20and%20dark%20alley%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20sharp%20contrast%20lighting%2C%20modern%20urban%20warrior%20theme&width=600&height=850&seq=comic-cover-03&orientation=portrait',
    rating: 9.1,
    category: 'action',
    categoryName: '动作',
    summary: '退役特种兵化身都市猎人，在繁华都市的暗处执行各种危险任务。',
    tags: ['动作', '都市', '热血'],
    views: 1950000,
    status: '连载中',
    chapters: Array.from({ length: 85 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《都市猎人》是一部令人热血沸腾的韩国动作漫画，由朴志勋创作，讲述了退役特种部队成员在都市中对抗罪恶的精彩故事。</p>
      <p>主角姜赫曾是韩国最精锐特种部队的王牌，在一次任务中失去了最亲密的战友后选择退役。他本想隐姓埋名过平凡生活，却发现繁华都市的阴影中隐藏着比战场更加险恶的阴谋。他化身都市猎人，用自己独特的战斗技巧和正义信念，粉碎一个个犯罪组织的野心。</p>
    `,
    faqs: [
      { question: '《都市猎人》适合什么年龄段阅读？', answer: '《都市猎人》含有一定的动作场面和紧张情节，建议15岁以上读者阅读。作品的打斗场面精彩但不血腥，是一部老少皆宜的优秀韩国漫画。' },
    ],
  },
  4: {
    id: 4,
    title: '开心果日记',
    author: '崔美英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20a%20funny%20girl%20making%20silly%20faces%20in%20a%20bright%20school%20setting%2C%20cheerful%20and%20colorful%20illustration%2C%20Korean%20webtoon%20chibi%20style%2C%20playful%20expressions%2C%20warm%20and%20happy%20atmosphere%2C%20cute%20character%20design&width=600&height=850&seq=comic-cover-04&orientation=portrait',
    rating: 9.0,
    category: 'comedy',
    categoryName: '搞笑',
    summary: '一个天生自带笑点的女孩的日常生活，每一页都充满意想不到的笑料。',
    tags: ['搞笑', '日常', '校园'],
    views: 1680000,
    status: '连载中',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《开心果日记》由崔美英创作，是一部让人捧腹大笑的韩国搞笑漫画，适合所有年龄段读者阅读。</p>
      <p>女主角秀英从小学到进入职场，仿佛天生自带搞笑光环，无论走到哪里都能引发一连串令人哭笑不得的事件。从课堂上的迷糊回答到办公室里的乌龙事件，秀英用她独特的乐观精神感染着身边的每一个人。</p>
    `,
    faqs: [],
  },
  5: {
    id: 5,
    title: '暗黑追踪',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20thriller%20comic%20cover%20with%20a%20detective%20in%20a%20dark%20rainy%20alley%2C%20mysterious%20silhouette%20in%20the%20background%2C%20noir%20atmosphere%2C%20Korean%20webtoon%20art%2C%20cold%20blue%20tones%20with%20red%20accents%2C%20suspenseful%20mood%2C%20cinematic%20composition&width=600&height=850&seq=comic-cover-05&orientation=portrait',
    rating: 8.9,
    category: 'thriller',
    categoryName: '悬疑',
    summary: '天才犯罪心理分析师与老练刑警联手追查连环案件，揭开隐藏在黑暗中的惊人真相。',
    tags: ['悬疑', '犯罪', '推理'],
    views: 1520000,
    status: '连载中',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《暗黑追踪》是一部扣人心弦的韩国悬疑漫画，创作者郑宇成用精妙的叙事和复杂的案件设计，为读者呈现了一个充满悬念与反转的精彩故事。</p>
      <p>首尔连续发生多起离奇案件，天才犯罪心理分析师崔敏俊与老练刑警张德秀组成了特别调查组。随着调查深入，他们发现这些看似毫无关联的案件背后，隐藏着一个横跨数十年、涉及政商两界的惊天阴谋。</p>
    `,
    faqs: [],
  },
  6: {
    id: 6,
    title: '逆天医仙',
    author: '韩志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20a%20mystical%20healer%20surrounded%20by%20floating%20herbs%20and%20ancient%20symbols%2C%20eastern%20fantasy%20aesthetic%2C%20Korean%20webtoon%20illustration%2C%20ethereal%20green%20and%20gold%20tones%2C%20mystical%20atmosphere%2C%20wise%20character%20design&width=600&height=850&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    category: 'fantasy',
    categoryName: '奇幻',
    summary: '现代医学生穿越到修真世界，凭借现代医学知识结合修真功法，成为一代传奇医仙。',
    tags: ['奇幻', '修真', '医学'],
    views: 2300000,
    status: '连载中',
    chapters: Array.from({ length: 110 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《逆天医仙》是韩志浩创作的奇幻修真类韩国漫画，以独特的医学修真设定获得了广大读者的喜爱。</p>
      <p>天才医学生陈逸凡在一次实验事故中意外穿越到一个修真世界。在这里他发现，现代医学知识与修真功法竟然存在着惊人的契合点。凭借扎实的医学基础，他在修真之路上开辟出了一条前人从未走过的医道之路。</p>
    `,
    faqs: [],
  },
  7: {
    id: 7,
    title: '校园罗曼史',
    author: '孙艺珍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20school%20romance%20comic%20cover%20with%20a%20couple%20under%20cherry%20blossom%20trees%20in%20school%20uniform%2C%20soft%20pink%20and%20white%20tones%2C%20Korean%20webtoon%20aesthetic%2C%20youthful%20and%20pure%20atmosphere%2C%20delicate%20art%20style%2C%20romantic%20spring%20scene&width=600&height=850&seq=comic-cover-07&orientation=portrait',
    rating: 8.8,
    category: 'romance',
    categoryName: '恋爱',
    summary: '高中校园里最不起眼的女孩与全校最受欢迎的男孩之间发生的甜蜜故事。',
    tags: ['恋爱', '校园', '青春'],
    views: 1350000,
    status: '连载中',
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《校园罗曼史》是孙艺珍创作的青春校园恋爱漫画，以清新自然的画风和真实细腻的情感描写打动了无数读者。</p>
      <p>在首尔一所普通高中，成绩优异却性格内向的裴智秀与校园人气王李民浩因为一次偶然的图书馆相遇产生了交集。看似不般配的两个人，在日常相处中慢慢发现了彼此身上独特的魅力，一段纯粹的校园爱情悄然萌芽。</p>
    `,
    faqs: [],
  },
  8: {
    id: 8,
    title: '末日求生',
    author: '崔胜贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20post%20apocalyptic%20comic%20cover%20with%20a%20survivor%20in%20ruined%20city%2C%20dramatic%20orange%20sky%2C%20Korean%20webtoon%20art%20style%2C%20intense%20survival%20theme%2C%20gritty%20atmosphere%2C%20dynamic%20action%20composition%2C%20rugged%20character%20design&width=600&height=850&seq=comic-cover-08&orientation=portrait',
    rating: 9.0,
    category: 'action',
    categoryName: '动作',
    summary: '文明崩塌后的幸存者们在废土之上为生存而战。',
    tags: ['动作', '末日', '生存'],
    views: 1780000,
    status: '连载中',
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《末日求生》是崔胜贤创作的末日生存题材韩国漫画，以紧张刺激的剧情和细腻的人物刻画赢得了读者的高度评价。</p>
      <p>一场全球性的超级病毒爆发后，人类文明在短短数周内崩塌。幸存者们不得不在废土之上面对资源匮乏、变异生物和人性黑暗的三重考验。主角金振宇在灾难中失去了家人，他必须学会在这个残酷的新世界中生存下去，同时寻找重建文明的希望。</p>
    `,
    faqs: [],
  },
  9: {
    id: 9,
    title: '灵异侦探社',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20comic%20cover%20with%20a%20ghost%20hunter%20in%20a%20haunted%20mansion%2C%20spooky%20atmosphere%20with%20green%20glowing%20eyes%2C%20Korean%20webtoon%20art%2C%20dark%20and%20eerie%20composition%2C%20supernatural%20horror%20theme%2C%20chilling%20mood&width=600&height=850&seq=comic-cover-09&orientation=portrait',
    rating: 8.7,
    category: 'horror',
    categoryName: '恐怖',
    summary: '拥有阴阳眼的少年组建灵异侦探社，专门解决各类超自然事件。',
    tags: ['恐怖', '灵异', '侦探'],
    views: 1250000,
    status: '连载中',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《灵异侦探社》是姜东元创作的超自然恐怖漫画，融合了灵异、侦探和恐怖元素，带来令人毛骨悚然的阅读体验。</p>
      <p>从小就拥有阴阳眼的李玄宇在成年后组建了一支特殊的侦探团队——灵异侦探社。他们专门接取普通人无法理解、警方束手无策的超自然案件。从闹鬼公寓到都市传说，每一个案件不仅是与鬼魂的较量，更是对人性深处的探索。</p>
    `,
    faqs: [],
  },
  10: {
    id: 10,
    title: '星光之路',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20comic%20cover%20with%20a%20young%20actress%20on%20stage%20under%20spotlight%2C%20theatrical%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20elegant%20and%20emotional%20composition%2C%20warm%20stage%20lighting%2C%20show%20business%20theme&width=600&height=850&seq=comic-cover-10&orientation=portrait',
    rating: 9.4,
    category: 'drama',
    categoryName: '剧情',
    summary: '从默默无闻的练习生到万众瞩目的明星，一个女孩在演艺圈的奋斗史。',
    tags: ['剧情', '演艺圈', '励志'],
    views: 2600000,
    status: '连载中',
    chapters: Array.from({ length: 90 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《星光之路》是金秀贤创作的演艺圈题材剧情漫画，以其真实的行业描写和感人的成长故事受到了广泛好评。</p>
      <p>安秀妍从10岁起就成为练习生，在竞争激烈的韩国演艺圈中摸爬滚打了整整8年。经历了无数次的淘汰、背叛和自我怀疑，她最终凭借不屈的意志和纯粹的热爱，一步步走向了聚光灯的中心。这是一部关于梦想与坚持的韩国漫画，打动每一位心怀梦想的读者。</p>
    `,
    faqs: [],
  },
  11: {
    id: 11,
    title: '魔女的条件',
    author: '林允儿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20a%20witch%20casting%20magic%20in%20a%20mystical%20forest%2C%20magical%20sparkles%20and%20vines%2C%20Korean%20webtoon%20art%2C%20enchanting%20purple%20and%20green%20tones%2C%20fantasy%20witch%20theme%2C%20beautiful%20mystical%20character&width=600&height=850&seq=comic-cover-11&orientation=portrait',
    rating: 8.6,
    category: 'fantasy',
    categoryName: '奇幻',
    summary: '被选为魔女继承者的普通女孩，在魔法学院中面对各种挑战。',
    tags: ['奇幻', '魔法', '学院'],
    views: 1100000,
    status: '连载中',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《魔女的条件》是林允儿创作的魔法学院题材奇幻漫画，讲述了一个普通女孩在命运转折点的精彩冒险。</p>
      <p>平凡的高中生尹世罗在某天突然收到了一封来自亚尔克魔法学院的录取通知书，被告知自己是被选中的魔女继承者。在魔法学院中，她不仅要面对陌生的魔法世界、复杂的课业，还要解开自己身世之谜以及隐藏在学院深处的古老秘密。</p>
    `,
    faqs: [],
  },
  12: {
    id: 12,
    title: '爆笑一家人',
    author: '朴明秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20a%20chaotic%20family%20of%20five%20making%20funny%20faces%2C%20bright%20and%20colorful%20home%20scene%2C%20Korean%20webtoon%20aesthetic%2C%20warm%20family%20comedy%20theme%2C%20humorous%20expressions%2C%20lively%20illustration&width=600&height=850&seq=comic-cover-12&orientation=portrait',
    rating: 8.5,
    category: 'comedy',
    categoryName: '搞笑',
    summary: '五口之家的爆笑日常生活，每一刻都充满不可预测的搞笑事件。',
    tags: ['搞笑', '家庭', '日常'],
    views: 980000,
    status: '连载中',
    chapters: Array.from({ length: 102 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    descriptionHtml: `
      <h2>作品简介</h2>
      <p>《爆笑一家人》是朴明秀创作的家庭喜剧漫画，以五口之家的日常生活为背景，用幽默诙谐的笔触描绘了一幅温馨又搞笑的家庭画卷。</p>
      <p>爸爸是个不着调的上班族，妈妈是掌控全家的女王，大女儿是个高冷学霸，二儿子是个游戏宅男，小女儿是个调皮捣蛋鬼。五个性格迥异的家庭成员挤在一个屋檐下，每一天都上演着令人捧腹的精彩戏码。</p>
    `,
    faqs: [],
  },
};